var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 7.70711C0.402369 7.31658 0.402369 6.68342 0.792893 6.29289L6.79289 0.292893C7.18342 -0.0976314 7.81658 -0.0976314 8.20711 0.292894L14.2071 6.29289C14.5976 6.68342 14.5976 7.31658 14.2071 7.70711C13.8166 8.09763 13.1834 8.09763 12.7929 7.70711L7.5 2.41421L2.20711 7.70711C1.81658 8.09763 1.18342 8.09763 0.792893 7.70711Z",
    fill: "var(--white-200)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c257c41a98c19a00dfa34a11990080f9.svg";
export { ForwardRef as ReactComponent };